import { Injectable, Injector } from '@angular/core';
import { SortOption } from '@core';
import { Observable } from 'rxjs';
import { DocListBaseService } from 'src/app/shared-feature/services/_base/doc-list-base.service';

@Injectable()
export class SdnListService extends DocListBaseService {
  url = 'api/salesdns/list';
  expandProperties =
    'Customer($select=Code),Currency($select=Code),Agent($select=Code),Term($select=Code)';
  override searchColumns: string[] = [
    'DocCode',
    'Description',
    'Customer/Code',
    'CustomerName',
    'Agent/Code',
    'Term/Code'
  ];
  sortOptions: SortOption[] = [
    { title: 'Date', sort: 'docDate' },
    { title: 'Doc #', sort: 'docCode' },
    { title: 'Customer #', sort: 'Customer/Code' },
    { title: 'Customer Name', sort: 'CustomerName' },
    { title: 'Agent #', sort: 'Agent/Code' },
    { title: 'Term', sort: 'Term/Code' },
    { title: 'Due Date', sort: 'dueDate' },
    { title: 'Term', sort: 'termCode' },
    { title: 'Amount', sort: 'netTotalAmount' },
    { title: 'Ref. No', sort: 'referenceNo' },
    { title: 'Validated On', sort: 'validateOn' }
  ];

  override onAction(action: string, data: any): Promise<boolean> {
    if (action === 'matchToAROR') {
      return this.confirmValidToKnockoff(data.map((x: any) => x.id));
    }
    return super.onAction(action, data);
  }

  batchDelete(ids: any[]): Observable<any> {
    return this.http.delete('api/salesdns', null, { body: { ids: ids } });
  }
  constructor(injector: Injector) {
    super(injector);
  }

  confirmValidToKnockoff(ids: any[]): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http
        .post('api/salesdns/IsValidKnockedoff', { ids: ids }, { _silent: true })
        .subscribe(res => {
          if(res > 0) {
            this.match(ids, res);
            resolve(true);
          }
          else {
            if(res === -1){
              this.msg.error('<b>Sales Debit Note(s) is already knocked-off.')
            }
            if(res === -2){
              this.msg.error('<b>Sales Debit Note(s) that have been selected have different customer IDs.')
            }
            reject();
          }
        });
    });
  }

  match(row: any[], customerId: any){
    this.router.navigate(['/ar/or/detail/0'], { queryParams: { customerId: customerId, docType: 'SDN', toKnockoffBatch: row } });
  }
}
